import { render, staticRenderFns } from "./PersonValidation.vue?vue&type=template&id=b59d9816&"
import script from "./PersonValidation.vue?vue&type=script&setup=true&lang=js&"
export * from "./PersonValidation.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports